// validarFormulario.js

const limparTexto = (texto) => (texto || '').trim();
const validarEmail = (email) => /\S+@\S+\.\S+/.test(email);

const validarFormulario = async (campos) => {
  const {
    nomeEmpresa, cpfCnpj, cep, endereco, estado, cidade, bairro, telefone,
    emailPrincipal, emailAlternativo, numero, complemento,
    dominio, tipoDominio,
    erroDominio, erroEmailPrincipal, erroNomeEmpresa,
    erroCpfCnpj, erroCep, erroEndereco, erroEstado, erroCidade, erroBairro,
    planoSelecionado
  } = campos;

  let valido = true;
  console.log('[VALIDAÇÃO] Iniciando...');

  // --- Validação do domínio ---
  if ((tipoDominio.value === 'registro' || tipoDominio.value === 'ja-tenho')) {
    const dominioLimpo = limparTexto(dominio.value);
    if (dominioLimpo.length === 0) {
      erroDominio.value = 'Por favor, preencha o nome do domínio.';
      valido = false;
    } else {
      erroDominio.value = '';
    }
  } else {
    erroDominio.value = '';
  }

  // --- Lista de campos obrigatórios com tamanho mínimo ---
  const obrigatorios = [
    ['nomeEmpresa', erroNomeEmpresa, '[NOME EMPRESA]', 4],
    ['cep', erroCep, '[CEP]', 8],
    ['endereco', erroEndereco, '[ENDEREÇO]', 5],
    ['estado', erroEstado, '[ESTADO]', 2],
    ['cidade', erroCidade, '[CIDADE]', 3],
    ['bairro', erroBairro, '[BAIRRO]', 4],
    ['emailPrincipal', erroEmailPrincipal, '[EMAIL PRINCIPAL]', 5]
  ];

  for (const [campoKey, erroRef, label, minLength] of obrigatorios) {
    const refValor = campos[campoKey];
    const valorLimpo = limparTexto(refValor.value);

    let erroAtual = '';

    if (valorLimpo.length === 0) {
      erroAtual = 'Campo obrigatório.';
      console.log(`${label} inválido - vazio`);
      valido = false;
    } else if (valorLimpo.length < minLength) {
      erroAtual = `O campo deve ter no mínimo ${minLength} caracteres.`;
      console.log(`${label} inválido - menos de ${minLength} caracteres`);
      valido = false;
    } else if (campoKey === 'emailPrincipal' && !validarEmail(valorLimpo)) {
      erroAtual = 'Formato de e-mail inválido.';
      console.log(`${label} inválido - formato de e-mail`);
      valido = false;
    } else {
      console.log(`${label} OK`);
    }

    erroRef.value = erroAtual;
  }

  // --- Validação do CPF/CNPJ assíncrona ---
  if (cpfCnpj && erroCpfCnpj && nomeEmpresa && erroNomeEmpresa) {
    const { default: validarCpfCnpj } = await import('./validarCpfCnpj.js');
    await validarCpfCnpj(cpfCnpj, erroCpfCnpj, nomeEmpresa, erroNomeEmpresa);
  }

  console.log('[VALIDAÇÃO] Final:', valido);
  return valido;
};

export default validarFormulario;
